import {Button, Modal} from 'antd';
import {ModalProps} from 'antd/es';
import styles from './index.module.scss';

export function ForgetModal({...props}: ModalProps) {
    return (
        <Modal {...props} title="忘记密码" footer={null}>
            <p>
                如果您忘记了平台的登录密码， 请联系系统管理员为您重置密码，
                重置密码成功后要先修改密码再重新登录。
            </p>

            <p>
                友情提示： 登录密码最少8、最多20个半角字符，要包含半角数字、
                大小写字母和半角特殊字符如“{'/\\[]:;|=,+#*?<>'}”。
            </p>

            <div className={styles.buttons}>
                <Button
                    type="primary"
                    className={styles.button}
                    onClick={props.onCancel}>
                    我知道了
                </Button>
            </div>
        </Modal>
    );
}
